class WorkBlock {
  constructor() {
    this.containers = Array.from(document.querySelectorAll('.js-work-block'));

    if (this.containers.length > 0) {
      this.containers.forEach(this.workBlock.bind(this));
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        this.containers.forEach(this.workBlock.bind(this));
      }
    });
  }

  workBlock(container) {
    const workTitles = container.querySelectorAll('.js-work-block-content');
    let tallestTitle = 50;

    // Loop over workTitles and get tallest.
    for (let i = 0; i < workTitles.length; i += 1) {
      const el = workTitles[i];
      const title = el.querySelector('.work-block__item-title');
      let titleHeight = 0;
      if (title) {
        titleHeight = title.offsetHeight;
      }
      const people = el.querySelector('.work-block__related-people');
      let peopleHeight = 0;
      if (people) {
        peopleHeight = people.offsetHeight;
      }
      const height = titleHeight + peopleHeight + 10;
      if (height > tallestTitle) {
        tallestTitle = height;
      }
    }

    const workBlocks = container.querySelectorAll('.work-block__item');
    // Loop over workBlocks and set grid rows.
    for (let i = 0; i < workBlocks.length; i += 1) {
      const el = workBlocks[i];
      el.style.gridTemplateRows = `1fr ${  tallestTitle  }px`;
    }
  }
}

export default WorkBlock;
